import React from 'react';
import { Container, Navbar, Nav } from 'react-bootstrap';

const TermsAndConditions = () => {
  const styles = {
    navbar: {
      backgroundColor: '#667eea',
      padding: '1rem 0',
      marginBottom: '0',
    },
    navbarBrand: {
      color: '#ffffff',
      fontSize: '24px',
      fontWeight: 'bold',
      textDecoration: 'none',
    },
    hero: {
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white',
      padding: '60px 0',
      marginBottom: '0',
    },
    heroTitle: {
      fontSize: '42px',
      fontWeight: 'bold',
      marginBottom: '15px',
      textAlign: 'center',
    },
    heroSubtitle: {
      fontSize: '18px',
      textAlign: 'center',
      opacity: '0.95',
    },
    container: {
      maxWidth: '900px',
      margin: '0 auto',
      padding: '40px 20px',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      lineHeight: '1.8',
      backgroundColor: '#ffffff',
    },
    section: {
      marginBottom: '35px',
      padding: '25px',
      backgroundColor: '#f8f9fa',
      borderRadius: '12px',
      border: '1px solid #e9ecef',
    },
    sectionTitle: {
      fontSize: '22px',
      fontWeight: '600',
      marginBottom: '15px',
      color: '#667eea',
      borderBottom: '2px solid #667eea',
      paddingBottom: '10px',
    },
    subsectionTitle: {
      fontSize: '18px',
      fontWeight: '600',
      marginTop: '20px',
      marginBottom: '10px',
      color: '#495057',
    },
    paragraph: {
      marginBottom: '15px',
      color: '#495057',
      fontSize: '15px',
    },
    list: {
      marginLeft: '20px',
      listStyleType: 'disc',
      color: '#495057',
    },
    listItem: {
      marginBottom: '8px',
      fontSize: '15px',
    },
    important: {
      backgroundColor: '#fff3cd',
      border: '1px solid #ffc107',
      borderRadius: '8px',
      padding: '15px',
      marginTop: '15px',
      marginBottom: '15px',
    },
    importantIcon: {
      color: '#ffc107',
      fontSize: '20px',
      marginRight: '10px',
    },
    footer: {
      textAlign: 'center',
      marginTop: '40px',
      padding: '30px 20px',
      backgroundColor: '#f8f9fa',
      borderRadius: '12px',
      fontSize: '14px',
      color: '#6c757d',
    },
    contactInfo: {
      backgroundColor: '#e7f1ff',
      padding: '20px',
      borderRadius: '8px',
      marginTop: '20px',
      border: '1px solid #b8daff',
    },
  };

  return (
    <>
      {/* Navbar */}
      <Navbar style={styles.navbar} expand="lg">
        <Container>
          <Navbar.Brand href="/" style={styles.navbarBrand}>
            Tasacionesya.com
          </Navbar.Brand>
          <Nav className="ms-auto">
            <Nav.Link href="/" style={{ color: 'white' }}>Inicio</Nav.Link>
          </Nav>
        </Container>
      </Navbar>

      {/* Hero Section */}
      <div style={styles.hero}>
        <Container>
          <h1 style={styles.heroTitle}>Términos y Condiciones de Uso</h1>
          <p style={styles.heroSubtitle}>Última actualización: 16 de enero de 2026</p>
        </Container>
      </div>

      {/* Content */}
      <div style={styles.container}>
        {/* Introduction */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>1. Introducción y Aceptación</h2>
          <p style={styles.paragraph}>
            Bienvenido a <strong>Tasacionesya.com</strong>, plataforma operada por <strong>Sr Realty Group S.A.S.</strong> 
            Estos Términos y Condiciones regulan el acceso y uso de nuestros servicios de valuación inmobiliaria y servicios relacionados.
          </p>
          <p style={styles.paragraph}>
            Al utilizar nuestro sitio web, realizar una valuación, registrarte como usuario o contratar cualquiera de nuestros servicios, 
            <strong> aceptas de forma expresa e irrevocable estos Términos y Condiciones en su totalidad</strong>.
          </p>
          <p style={styles.paragraph}>
            Si no estás de acuerdo con estos términos, debes abstenerte de utilizar nuestra plataforma.
          </p>
        </div>

        {/* Valuation Services */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>2. Servicios de Valuación</h2>
          
          <h3 style={styles.subsectionTitle}>2.1 Naturaleza de las Valuaciones</h3>
          <div style={styles.important}>
            <span style={styles.importantIcon}>⚠️</span>
            <strong>IMPORTANTE:</strong> Las valuaciones proporcionadas por Tasacionesya.com son estimaciones orientativas basadas en 
            algoritmos, datos de mercado y análisis automatizados. <strong>NO constituyen valuaciones oficiales, peritajes profesionales 
            ni tienen valor legal o probatorio</strong>.
          </div>
          <p style={styles.paragraph}>
            Nuestras valuaciones tienen carácter informativo y referencial. Para fines legales, hipotecarios, judiciales o cualquier 
            otro propósito que requiera una valuación oficial, deberás contratar los servicios de un tasador matriculado.
          </p>

          <h3 style={styles.subsectionTitle}>2.2 Limitaciones y Descargo de Responsabilidad</h3>
          <ul style={styles.list}>
            <li style={styles.listItem}>Las valuaciones pueden variar según las condiciones del mercado inmobiliario.</li>
            <li style={styles.listItem}>No garantizamos que el valor estimado coincida con el precio de venta final de la propiedad.</li>
            <li style={styles.listItem}>Las estimaciones se basan en información disponible públicamente y datos proporcionados por el usuario.</li>
            <li style={styles.listItem}>No nos responsabilizamos por decisiones comerciales o de inversión tomadas en base a nuestras valuaciones.</li>
          </ul>

          <h3 style={styles.subsectionTitle}>2.3 Consentimiento para Contacto y Marketing</h3>
          <div style={styles.important}>
            <span style={styles.importantIcon}>✓</span>
            <strong>Al solicitar una valuación, otorgas tu consentimiento expreso para:</strong>
          </div>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              <strong>Contacto Comercial:</strong> Autorizar a Sr Realty Group S.A.S. y sus agentes inmobiliarios a contactarte 
              por teléfono, WhatsApp, correo electrónico o cualquier otro medio disponible.
            </li>
            <li style={styles.listItem}>
              <strong>Ofertas de Servicios:</strong> Recibir información sobre nuestros servicios inmobiliarios, incluyendo pero no 
              limitándose a: venta de propiedades, alquiler, administración, valuaciones profesionales, asesoramiento inmobiliario y 
              servicios relacionados.
            </li>
            <li style={styles.listItem}>
              <strong>Marketing y Publicidad:</strong> Recibir comunicaciones de marketing, promociones, newsletters y contenido 
              informativo sobre el mercado inmobiliario.
            </li>
            <li style={styles.listItem}>
              <strong>Seguimiento Comercial:</strong> Ser contactado por nuestro equipo comercial para dar seguimiento a tu valuación 
              y ofrecerte servicios personalizados según tus necesidades inmobiliarias.
            </li>
          </ul>
          <p style={styles.paragraph}>
            Podrás solicitar la baja de nuestras comunicaciones en cualquier momento enviando un correo a info@tasacionesya.com 
            con el asunto "Baja de comunicaciones".
          </p>
        </div>

        {/* Premium Valuation Service */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>3. Servicio de Valuación Premium</h2>
          
          <h3 style={styles.subsectionTitle}>3.1 Descripción del Servicio Premium</h3>
          <p style={styles.paragraph}>
            El servicio de <strong>Valuación Premium</strong> es un producto de pago que ofrece una estimación de valor inmobiliario 
            mejorada mediante el uso de inteligencia artificial avanzada y búsqueda en tiempo real de propiedades similares en el mercado.
          </p>
          <p style={styles.paragraph}>
            El servicio Premium incluye:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}><strong>Análisis con IA avanzada:</strong> Utilización de inteligencia artificial con capacidad de búsqueda en internet en tiempo real</li>
            <li style={styles.listItem}><strong>Comparación de mercado:</strong> Análisis de 10-20 propiedades similares actualmente en el mercado (zonaprop.com.ar, argenprop.com, mercadolibre.com.ar)</li>
            <li style={styles.listItem}><strong>Algoritmo profesional:</strong> Combinación de nuestra base de datos interna con datos actuales del mercado</li>
            <li style={styles.listItem}><strong>Resultado instantáneo:</strong> Valuación entregada inmediatamente después del pago</li>
            <li style={styles.listItem}><strong>Asesoramiento incluido:</strong> Acceso a consulta personalizada con martillero profesional vía WhatsApp</li>
          </ul>

          <h3 style={styles.subsectionTitle}>3.2 Naturaleza del Servicio Premium</h3>
          <div style={styles.important}>
            <span style={styles.importantIcon}>⚠️</span>
            <strong>IMPORTANTE:</strong> Aunque el servicio Premium utiliza tecnología avanzada y análisis de mercado en tiempo real, 
            las valuaciones proporcionadas siguen siendo <strong>estimaciones orientativas y no constituyen valuaciones oficiales</strong>.
          </div>
          <p style={styles.paragraph}>
            El servicio Premium:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>NO es una valuación oficial o certificada</li>
            <li style={styles.listItem}>NO tiene valor legal, judicial o probatorio</li>
            <li style={styles.listItem}>NO reemplaza la valuación realizada por un tasador matriculado</li>
            <li style={styles.listItem}>Es una herramienta informativa y referencial para toma de decisiones</li>
          </ul>

          <h3 style={styles.subsectionTitle}>3.3 Condiciones de Pago</h3>
          <p style={styles.paragraph}>
            <strong>Procesamiento:</strong> Los pagos se procesan a través de MercadoPago. No almacenamos información de tarjetas de crédito.
          </p>
          <p style={styles.paragraph}>
            <strong>Precios:</strong> Los precios se muestran en pesos argentinos (ARS) antes de realizar el pago. Se pueden aplicar descuentos promocionales.
          </p>
          <p style={styles.paragraph}>
            <strong>Política de NO reembolso:</strong> Dado que el servicio Premium es digital y se entrega instantáneamente después del pago, 
            <strong> NO se realizan reembolsos una vez que la valuación ha sido generada y entregada</strong>.
          </p>
          <div style={styles.important}>
            <span style={styles.importantIcon}>⚠️</span>
            <strong>Al realizar el pago del servicio Premium, aceptas expresamente que el servicio se ejecutará inmediatamente y 
            renuncias a tu derecho de desistimiento.</strong>
          </div>

          <h3 style={styles.subsectionTitle}>3.4 Asesoramiento Profesional Incluido</h3>
          <p style={styles.paragraph}>
            El servicio Premium incluye acceso a asesoramiento personalizado con un martillero profesional mediante WhatsApp. Este servicio:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>Está disponible para consultas sobre la valuación recibida</li>
            <li style={styles.listItem}>Proporciona orientación sobre el mercado inmobiliario</li>
            <li style={styles.listItem}>NO constituye asesoramiento legal, financiero o de inversión</li>
            <li style={styles.listItem}>Es un servicio de orientación comercial e informativo</li>
            <li style={styles.listItem}>No garantiza tiempos de respuesta específicos, aunque nos esforzamos por responder en minutos</li>
          </ul>

          <h3 style={styles.subsectionTitle}>3.5 Privacidad en Servicio Premium</h3>
          <div style={styles.important}>
            <span style={styles.importantIcon}>🔒</span>
            <strong>Política de privacidad EXCLUSIVA del servicio Premium:</strong> Esta sección aplica ÚNICAMENTE a las valuaciones Premium de pago.
          </div>
          <p style={styles.paragraph}>
            <strong>Sin recopilación de datos personales para Premium:</strong> A diferencia del servicio gratuito, para adquirir 
            el servicio Premium NO es necesario proporcionar nombre, teléfono, email u otros datos personales. Solo se requiere:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>Información de la propiedad a valuar (dirección, características)</li>
            <li style={styles.listItem}>Información de pago (procesada por MercadoPago)</li>
          </ul>
          <p style={styles.paragraph}>
            <strong>No se utiliza para marketing:</strong> Los datos de valuaciones Premium NO se utilizan para contacto comercial 
            ni marketing, salvo que el usuario elija voluntariamente utilizar el servicio de asesoramiento incluido mediante WhatsApp.
          </p>
          <div style={styles.important}>
            <span style={styles.importantIcon}>⚠️</span>
            <strong>NOTA IMPORTANTE:</strong> El servicio de valuación GRATUITA sí requiere proporcionar número de teléfono y 
            los usuarios autorizan expresamente el contacto comercial y recepción de comunicaciones de marketing según se 
            establece en la Sección 2.3 de estos Términos y Condiciones.
          </div>

          <h3 style={styles.subsectionTitle}>3.6 Códigos Promocionales</h3>
          <p style={styles.paragraph}>
            Ocasionalmente podemos ofrecer códigos promocionales (códigos de descuento o códigos gratuitos) que pueden 
            aplicarse a servicios premium:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              <strong>Códigos de Descuento:</strong> Reducen el precio del servicio premium en un porcentaje específico. 
              El pago se procesa por el monto con descuento aplicado
            </li>
            <li style={styles.listItem}>
              <strong>Códigos Gratuitos:</strong> Permiten acceder al servicio premium sin costo alguno, omitiendo 
              completamente el proceso de pago
            </li>
          </ul>
          <div style={styles.important}>
            <span style={styles.importantIcon}>🎟️</span>
            <strong>Condiciones de uso de códigos promocionales:</strong>
          </div>
          <ul style={styles.list}>
            <li style={styles.listItem}>Los códigos promocionales son válidos por tiempo limitado y pueden tener fecha de vencimiento</li>
            <li style={styles.listItem}>Cada código puede tener restricciones específicas de uso (cantidad de usos, tipo de usuario, etc.)</li>
            <li style={styles.listItem}>Los códigos son intransferibles salvo autorización expresa</li>
            <li style={styles.listItem}>Nos reservamos el derecho de desactivar códigos en caso de uso fraudulento o abusivo</li>
            <li style={styles.listItem}>No se pueden combinar múltiples códigos en una misma operación</li>
            <li style={styles.listItem}>Los códigos no tienen valor monetario y no pueden ser canjeados por dinero</li>
            <li style={styles.listItem}>Nos reservamos el derecho de modificar o cancelar promociones sin previo aviso</li>
          </ul>

          <h3 style={styles.subsectionTitle}>3.7 Limitaciones y Descargo de Responsabilidad Específico</h3>
          <ul style={styles.list}>
            <li style={styles.listItem}>Los resultados dependen de la disponibilidad de datos en los sitios de terceros consultados</li>
            <li style={styles.listItem}>No garantizamos que los sitios externos tengan propiedades comparables en todos los casos</li>
            <li style={styles.listItem}>Las variaciones en el mercado pueden afectar la precisión de las estimaciones</li>
            <li style={styles.listItem}>No nos responsabilizamos por decisiones de compra, venta o inversión tomadas basándose en nuestras valuaciones</li>
            <li style={styles.listItem}>El servicio se proporciona "tal cual" sin garantías de ningún tipo</li>
          </ul>
        </div>

        {/* Registration and Account */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>4. Registro de Usuario y Cuenta</h2>
          
          <h3 style={styles.subsectionTitle}>4.1 Información Requerida</h3>
          <p style={styles.paragraph}>Para acceder a ciertas funcionalidades, podrás necesitar proporcionar:</p>
          <ul style={styles.list}>
            <li style={styles.listItem}>Nombre y apellido</li>
            <li style={styles.listItem}>Dirección de correo electrónico</li>
            <li style={styles.listItem}>Número de teléfono</li>
            <li style={styles.listItem}>Contraseña segura (hasheada y protegida en nuestros sistemas)</li>
            <li style={styles.listItem}>Dirección de la propiedad a tasar</li>
            <li style={styles.listItem}>Nombre de empresa (en caso de usuarios corporativos o agentes)</li>
          </ul>

          <h3 style={styles.subsectionTitle}>4.2 Tipos de Cuenta</h3>
          <p style={styles.paragraph}>Ofrecemos diferentes tipos de cuenta:</p>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              <strong>Usuario Personal:</strong> Para personas que desean valuar propiedades ocasionalmente
            </li>
            <li style={styles.listItem}>
              <strong>Usuario Corporativo:</strong> Para empresas que requieren valuaciones frecuentes
            </li>
            <li style={styles.listItem}>
              <strong>Agente Inmobiliario:</strong> Cuenta especial para profesionales del sector inmobiliario con acceso a 
              funcionalidades adicionales, historial de valuaciones, y créditos premium gratuitos iniciales
            </li>
          </ul>

          <h3 style={styles.subsectionTitle}>4.3 Cuentas de Agente Inmobiliario</h3>
          <div style={styles.important}>
            <span style={styles.importantIcon}>⭐</span>
            <strong>Beneficio Especial para Agentes:</strong> Los usuarios que se registran como "Agente Inmobiliario" 
            reciben automáticamente 2 (dos) créditos premium gratuitos para realizar valuaciones premium sin costo.
          </div>
          <p style={styles.paragraph}>
            Los créditos premium gratuitos para agentes:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>Se otorgan automáticamente al momento del registro como agente</li>
            <li style={styles.listItem}>Pueden ser utilizados para obtener valuaciones premium sin realizar pago</li>
            <li style={styles.listItem}>Son intransferibles y no tienen valor monetario</li>
            <li style={styles.listItem}>No tienen fecha de vencimiento</li>
            <li style={styles.listItem}>Una vez utilizados, las valuaciones premium adicionales deben ser abonadas</li>
          </ul>

          <h3 style={styles.subsectionTitle}>4.4 Responsabilidad del Usuario</h3>
          <p style={styles.paragraph}>
            Eres responsable de proporcionar información veraz, exacta y actualizada. La inexactitud de los datos proporcionados 
            puede afectar la calidad de nuestras estimaciones y servicios.
          </p>
          <p style={styles.paragraph}>
            Debes mantener la confidencialidad de tus credenciales de acceso (email y contraseña) y eres responsable de todas 
            las actividades que ocurran bajo tu cuenta. Notifícanos inmediatamente si sospechas un uso no autorizado de tu cuenta.
          </p>

          <h3 style={styles.subsectionTitle}>4.5 Seguridad de Contraseñas</h3>
          <p style={styles.paragraph}>
            Las contraseñas se almacenan utilizando algoritmos de hash criptográfico (bcrypt) con salt, lo que significa que 
            no almacenamos tu contraseña en texto plano y no podemos recuperarla. Si olvidas tu contraseña, deberás crear una nueva.
          </p>

          <h3 style={styles.subsectionTitle}>4.6 Eliminación de Cuenta</h3>
          <p style={styles.paragraph}>
            Puedes solicitar la eliminación de tu cuenta en cualquier momento desde la sección "Mi Cuenta" de tu perfil. 
            Al eliminar tu cuenta:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>Tu información personal será marcada como eliminada (soft delete)</li>
            <li style={styles.listItem}>No podrás acceder a tu historial de valuaciones</li>
            <li style={styles.listItem}>El proceso es irreversible y no podrás recuperar tu cuenta</li>
            <li style={styles.listItem}>Algunos datos pueden conservarse por obligaciones legales y contables</li>
            <li style={styles.listItem}>Tu dirección de email será modificada para prevenir reutilización</li>
          </ul>
          <div style={styles.important}>
            <span style={styles.importantIcon}>⚠️</span>
            <strong>IMPORTANTE:</strong> La eliminación de cuenta es permanente. Asegúrate de descargar cualquier 
            información que desees conservar antes de eliminar tu cuenta.
          </div>
        </div>

        {/* Privacy and Data Protection */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>5. Privacidad y Protección de Datos</h2>
          
          <h3 style={styles.subsectionTitle}>5.1 Recopilación de Datos</h3>
          <p style={styles.paragraph}>Recopilamos y procesamos los siguientes datos:</p>
          <ul style={styles.list}>
            <li style={styles.listItem}>Información de contacto (nombre, email, teléfono)</li>
            <li style={styles.listItem}>Credenciales de acceso (contraseñas hasheadas con bcrypt)</li>
            <li style={styles.listItem}>Datos de la propiedad (dirección, características, tipo de operación)</li>
            <li style={styles.listItem}>Información de navegación (dirección IP, cookies, comportamiento en el sitio)</li>
            <li style={styles.listItem}>Datos de transacciones y pagos (procesados por MercadoPago)</li>
            <li style={styles.listItem}>Historial de valuaciones y uso de créditos premium (para cuentas de agente)</li>
          </ul>

          <h3 style={styles.subsectionTitle}>5.2 Uso de los Datos</h3>
          <p style={styles.paragraph}>Los datos recopilados se utilizan para:</p>
          <ul style={styles.list}>
            <li style={styles.listItem}>Proporcionar y mejorar nuestros servicios de valuación</li>
            <li style={styles.listItem}>Gestionar tu cuenta de usuario y autenticación</li>
            <li style={styles.listItem}>Administrar créditos premium y códigos promocionales</li>
            <li style={styles.listItem}>Mantener historial de valuaciones (para usuarios con cuenta)</li>
            <li style={styles.listItem}>Contactarte con fines comerciales y de marketing</li>
            <li style={styles.listItem}>Enviar newsletters, promociones y contenido informativo</li>
            <li style={styles.listItem}>Ofrecer servicios inmobiliarios personalizados</li>
            <li style={styles.listItem}>Análisis estadístico y mejora de la plataforma</li>
            <li style={styles.listItem}>Cumplimiento de obligaciones legales y regulatorias</li>
          </ul>

          <h3 style={styles.subsectionTitle}>5.3 Gestión de Historial de Valuaciones</h3>
          <p style={styles.paragraph}>
            Los usuarios con cuenta de agente pueden gestionar su historial de valuaciones:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              <strong>Ocultación de valuaciones:</strong> Los agentes pueden ocultar valuaciones de su vista personal. 
              Las valuaciones ocultas permanecen en el sistema para fines administrativos y contables, pero no son 
              visibles en el panel del usuario.
            </li>
            <li style={styles.listItem}>
              <strong>Acceso administrativo:</strong> El equipo de administración mantiene acceso completo a todas las 
              valuaciones, incluidas las ocultas, para fines de soporte, auditoría y cumplimiento regulatorio.
            </li>
          </ul>

          <h3 style={styles.subsectionTitle}>5.4 Protección y Seguridad</h3>
          <p style={styles.paragraph}>
            Implementamos múltiples capas de seguridad para proteger tu información:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              <strong>Encriptación de contraseñas:</strong> Utilizamos bcrypt con salt para hashear contraseñas
            </li>
            <li style={styles.listItem}>
              <strong>Bases de datos seguras:</strong> Almacenamiento en MongoDB con autenticación y acceso restringido
            </li>
            <li style={styles.listItem}>
              <strong>Tokens de autenticación:</strong> Sistema de tokens seguros para sesiones de usuario
            </li>
            <li style={styles.listItem}>
              <strong>Auditoría de accesos:</strong> Registro de acciones críticas en el sistema
            </li>
          </ul>
          <p style={styles.paragraph}>
            Sin embargo, ningún sistema es completamente infalible y no podemos garantizar la seguridad absoluta. 
            Te recomendamos mantener seguras tus credenciales de acceso.
          </p>

          <h3 style={styles.subsectionTitle}>5.5 Derechos del Usuario</h3>
          <p style={styles.paragraph}>
            De acuerdo con la Ley 25.326 de Protección de Datos Personales de Argentina, tienes derecho a:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>Acceder a tus datos personales y obtener información sobre su tratamiento</li>
            <li style={styles.listItem}>Rectificar datos inexactos o incompletos</li>
            <li style={styles.listItem}>Actualizar tu información de perfil</li>
            <li style={styles.listItem}>Solicitar la supresión de tus datos (eliminar cuenta)</li>
            <li style={styles.listItem}>Oponerte al tratamiento de datos para fines de marketing</li>
            <li style={styles.listItem}>Exportar tu historial de valuaciones</li>
          </ul>
          <p style={styles.paragraph}>
            Para ejercer estos derechos, contacta a info@tasacionesya.com o utiliza las opciones disponibles en tu cuenta.
          </p>
        </div>

        {/* Use of Platform */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>6. Uso de la Plataforma</h2>
          
          <h3 style={styles.subsectionTitle}>6.1 Licencia de Uso</h3>
          <p style={styles.paragraph}>
            Se te concede una licencia limitada, no exclusiva, intransferible y revocable para acceder y utilizar la plataforma 
            únicamente para fines personales y no comerciales.
          </p>

          <h3 style={styles.subsectionTitle}>6.2 Conductas Prohibidas</h3>
          <p style={styles.paragraph}>Está estrictamente prohibido:</p>
          <ul style={styles.list}>
            <li style={styles.listItem}>Utilizar la plataforma con fines ilícitos o fraudulentos</li>
            <li style={styles.listItem}>Intentar acceder a áreas restringidas del sistema</li>
            <li style={styles.listItem}>Realizar ingeniería inversa, copiar o distribuir nuestro software</li>
            <li style={styles.listItem}>Sobrecargar o interferir con el funcionamiento de los servidores</li>
            <li style={styles.listItem}>Proporcionar información falsa o engañosa</li>
            <li style={styles.listItem}>Violar derechos de propiedad intelectual</li>
            <li style={styles.listItem}>Utilizar robots, scrapers o herramientas automatizadas sin autorización</li>
          </ul>
        </div>

        {/* Intellectual Property */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>7. Propiedad Intelectual</h2>
          <p style={styles.paragraph}>
            Todo el contenido de la plataforma, incluyendo pero no limitándose a texto, gráficos, logotipos, iconos, imágenes, 
            clips de audio, descargas digitales, compilaciones de datos, algoritmos y software, es propiedad exclusiva de 
            Sr Realty Group S.A.S. o sus licenciantes y está protegido por las leyes de propiedad intelectual de Argentina 
            y tratados internacionales.
          </p>
          <p style={styles.paragraph}>
            Queda prohibida la reproducción, distribución, modificación, exhibición pública o creación de obras derivadas sin 
            autorización expresa y por escrito.
          </p>
        </div>

        {/* Payments and Services */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>8. Pagos y Otros Servicios</h2>
          
          <h3 style={styles.subsectionTitle}>7.1 Procesamiento de Pagos</h3>
          <p style={styles.paragraph}>
            Los pagos se procesan de forma segura a través de <strong>MercadoPago</strong>. No almacenamos información de 
            tarjetas de crédito en nuestros servidores.
          </p>

          <h3 style={styles.subsectionTitle}>7.2 Precios</h3>
          <p style={styles.paragraph}>
            Los precios de nuestros servicios se muestran en pesos argentinos (ARS) o dólares estadounidenses (USD) según 
            corresponda, e incluyen los impuestos aplicables. Nos reservamos el derecho de modificar los precios en cualquier momento.
          </p>

          <h3 style={styles.subsectionTitle}>7.3 Política de Reembolsos</h3>
          <p style={styles.paragraph}>
            Ofrecemos reembolsos dentro de los 7 días posteriores a la compra, siempre que el servicio no haya sido utilizado. 
            Para solicitar un reembolso, contacta a info@tasacionesya.com especificando el motivo de tu solicitud.
          </p>
        </div>

        {/* Liability Limitations */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>9. Limitación de Responsabilidad</h2>
          
          <h3 style={styles.subsectionTitle}>8.1 Descargo General</h3>
          <p style={styles.paragraph}>
            La plataforma se proporciona "tal cual" y "según disponibilidad". No garantizamos que el servicio será ininterrumpido, 
            seguro o libre de errores.
          </p>

          <h3 style={styles.subsectionTitle}>8.2 Exclusión de Garantías</h3>
          <p style={styles.paragraph}>
            Excluimos todas las garantías, expresas o implícitas, incluidas las garantías de comerciabilidad, idoneidad para 
            un propósito particular y no infracción, en la máxima medida permitida por la ley.
          </p>

          <h3 style={styles.subsectionTitle}>8.3 Limitación de Daños</h3>
          <p style={styles.paragraph}>
            En ningún caso seremos responsables por daños indirectos, incidentales, especiales, consecuentes o punitivos, 
            incluidos lucro cesante, pérdida de datos, daño a la reputación o pérdida de oportunidades comerciales, derivados 
            del uso o la imposibilidad de usar nuestros servicios.
          </p>
        </div>

        {/* Third Party Links */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>10. Enlaces a Terceros</h2>
          <p style={styles.paragraph}>
            Nuestro sitio puede contener enlaces a sitios web de terceros. No controlamos ni asumimos responsabilidad por el 
            contenido, políticas de privacidad o prácticas de sitios de terceros. Reconoces y aceptas que no seremos responsables 
            de ningún daño derivado del uso de dichos sitios.
          </p>
        </div>

        {/* Modifications */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>11. Modificaciones de los Términos</h2>
          <p style={styles.paragraph}>
            Nos reservamos el derecho de modificar estos Términos y Condiciones en cualquier momento. Las modificaciones entrarán 
            en vigor inmediatamente después de su publicación en el sitio web. Es tu responsabilidad revisar periódicamente estos 
            términos.
          </p>
          <p style={styles.paragraph}>
            El uso continuado de la plataforma después de las modificaciones constituye tu aceptación de los nuevos términos.
          </p>
        </div>

        {/* Governing Law */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>12. Ley Aplicable y Jurisdicción</h2>
          <p style={styles.paragraph}>
            Estos Términos y Condiciones se regirán e interpretarán de acuerdo con las leyes de la <strong>República Argentina</strong>.
          </p>
          <p style={styles.paragraph}>
            Para cualquier controversia derivada de estos términos o del uso de la plataforma, las partes se someten a la 
            jurisdicción exclusiva de los tribunales ordinarios de la Ciudad Autónoma de Buenos Aires, Argentina, renunciando 
            expresamente a cualquier otro fuero o jurisdicción que pudiera corresponderles.
          </p>
        </div>

        {/* Contact */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>13. Contacto</h2>
          <p style={styles.paragraph}>
            Para cualquier consulta, reclamo o ejercicio de tus derechos relacionados con estos Términos y Condiciones, puedes contactarnos:
          </p>
          <div style={styles.contactInfo}>
            <p style={{ margin: '5px 0', fontSize: '15px' }}>
              <strong>Sr Realty Group S.A.S.</strong>
            </p>
            <p style={{ margin: '5px 0', fontSize: '15px' }}>
              Email: <a href="mailto:info@tasacionesya.com" style={{ color: '#667eea' }}>info@tasacionesya.com</a>
            </p>
            <p style={{ margin: '5px 0', fontSize: '15px' }}>
              Sitio web: <a href="https://tasacionesya.com" style={{ color: '#667eea' }}>www.tasacionesya.com</a>
            </p>
          </div>
        </div>

        {/* Footer */}
        <div style={styles.footer}>
          <p style={{ marginBottom: '10px' }}>
            <strong>Fecha de última actualización: 16 de enero de 2026</strong>
          </p>
          <p style={{ fontSize: '13px', marginTop: '15px' }}>
            © 2026 Tasacionesya.com - Sr Realty Group S.A.S. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </>
  );
};

export default TermsAndConditions;
